










import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Dots extends Vue {
  @Prop() width?: number;
  @Prop() height?: number;
  @Prop() top?: boolean;
  @Prop() left?: boolean;
  border = 2;
  
  condition(i: number, j: number): boolean {
    if(this.top && this.left) {
      return i<=this.border || j<=this.border;
    } else if(this.top && !this.left) {
      return i<=this.border || j>5;
    } else if(!this.top && this.left) {
      return i>4 || j<=this.border;
    } else {
      return i>4 || j>5;
    }
    
  }
}
